/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { Maybe } from '@irian-ro/util-functions';

export class ShipmentSelectableListViewVO extends JSONable {
  owner: Maybe<string> | undefined = undefined;
  uuid: Maybe<string> | undefined = undefined;
  series: Maybe<string> | undefined = undefined;
  orderNumber: Maybe<string> | undefined = undefined;
  externalReference: Maybe<string> | undefined = undefined;
}
